"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShadowDom = exports.shadowDomTestId = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_dom_1 = require("react-dom");
exports.shadowDomTestId = 'activity_feed-shadow_host';
const ShadowDom = ({ children }) => {
    const shadowHostRef = (0, react_1.useRef)(null);
    const [shadowRoot, setShadowRoot] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        const rootElement = shadowHostRef.current?.attachShadow({ mode: 'open' });
        setShadowRoot(rootElement);
    }, []);
    return ((0, jsx_runtime_1.jsx)("div", { "data-testid": exports.shadowDomTestId, ref: shadowHostRef, children: shadowRoot ? (0, react_dom_1.createPortal)(children, shadowRoot) : null }));
};
exports.ShadowDom = ShadowDom;
//# sourceMappingURL=shadowDOM.js.map